module.exports = {"markup":"<span class=\"inline-cursor inline-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 95.828 95.828\" enable-background=\"new 0 0 95.828 95.828\"><path fill=\"#fff\" d=\"m71 27.4l-18 41-1.7-.1-4-13.7-15.8 15.8-6-6 15.8-15.8-13.7-4-.1-1.7 41-18 2.3 2.3m25 20.5c0-26.5-21.5-47.9-47.9-47.9s-47.9 21.5-47.9 47.9 21.5 47.9 47.9 47.9 47.9-21.5 47.9-47.9\"/></svg></span>"}


//////////////////
// WEBPACK FOOTER
// ./static/src/inline-svgs/icon/cursor.svg
// module id = 326
// module chunks = 5 15